<template>
    <header class="app-header" v-if='!user'>
        <div class="container-fluid">
            <router-link to="/">
                <img src="@/assets/images/common/LogoApp.svg" alt="Asia Actual Logo"/>
            </router-link>
            <div class="user-action-wrapper">
                <router-link to="/login">
                    <a>Log In</a>
                </router-link>
                <router-link v-if='user' to="/search">
                    <a>Free Trial</a>
                </router-link>
                <router-link v-else to="/pricing-plan">
                    <a>Free Trial</a>
                </router-link>
                <router-link to="/pricing-plan" class="orange-btn">
                    <a>Become a Member</a>
                </router-link>
            </div>
        </div>
    </header>
</template>

<script>
import * as isUserLoggedIn from '@/store/isUserLoggedIn';
export default {
    name: 'header',
    data() {
        return {
            user: isUserLoggedIn.isUserLoggedIn()
        }
    },
}
</script>

<style lang="scss">
    header.app-header {
        box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);

        .container-fluid {
            max-width: 1720px;
            width: 90%;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 22px 0;

            .user-action-wrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 420px;

                a {
                    color: #333;
                }

                .orange-btn {
                    width: 210px;
                    background: linear-gradient(312.89deg, #FC7C05 7.78%, #FCAF05 75.92%);

                    a {
                        color: #fff;
                    }
                }
            }
        }
    }
</style>